// extracted by mini-css-extract-plugin
export default {"h2":"Play_h2__RJI+1","subheading":"Play_subheading__noYSY","rightalign":"Play_rightalign__+STak","polaroid":"Play_polaroid__SwOXX","stickyTitle":"Play_stickyTitle__O-r7A"};